/* Muskoka native lead form engine.
   - Renders steps or a single page from window.MK_FORMS[type]
   - Submits to the HubSpot Forms API (no redirect, no personal data in URLs)
   - Pushes one `generate_lead` event to dataLayer (no names or emails; hashed user_data only) */
(function () {
  'use strict';
  var CFG = window.MK_FORMS;
  if (!CFG || window.__mkFormLoaded) return;
  window.__mkFormLoaded = true;

  function el(tag, attrs, kids) {
    var n = document.createElement(tag);
    Object.keys(attrs || {}).forEach(function (k) {
      if (k === 'class') n.className = attrs[k];
      else if (k === 'text') n.textContent = attrs[k];
      else if (attrs[k] === true) n.setAttribute(k, '');
      else if (attrs[k] !== false && attrs[k] != null) n.setAttribute(k, attrs[k]);
    });
    (kids || []).forEach(function (c) { if (c) n.appendChild(typeof c === 'string' ? document.createTextNode(c) : c); });
    return n;
  }
  function uid() { return 'mk' + Math.random().toString(36).slice(2, 8); }
  function cookie(n) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + n + '=([^;]*)'));
    if (!m) return null;
    try { return decodeURIComponent(m[1]); } catch (e) { return null; }
  }
  function json(s) { try { return JSON.parse(s); } catch (e) { return {}; } }
  function sha256(str) {
    if (!(window.crypto && crypto.subtle && window.TextEncoder)) return Promise.resolve('');
    return crypto.subtle.digest('SHA-256', new TextEncoder().encode(str)).then(function (b) {
      return Array.prototype.map.call(new Uint8Array(b), function (x) { return ('0' + x.toString(16)).slice(-2); }).join('');
    }).catch(function () { return ''; });
  }
  function market() { return (window.Shopify && Shopify.routes && /^\/en-us/i.test(Shopify.routes.root || '')) || /^\/en-us(\/|$)/i.test(location.pathname) ? 'US' : 'CA'; }

  // true while the clock in the given time zone is inside the open hours (days: 0 = Sunday)
  function inHours(h) {
    // Preview switch: add ?mk_open=1 to the URL to see the in-hours experience. Only honored on a theme that is not published.
    try {
      var role = window.Shopify && Shopify.theme && Shopify.theme.role;
      if (role && role !== 'main' && /[?&]mk_open=1\b/.test(location.search)) return true;
    } catch (e) { /* ignore */ }
    try {
      var parts = new Intl.DateTimeFormat('en-US', { timeZone: h.tz, weekday: 'short', hour: 'numeric', minute: 'numeric', hour12: false }).formatToParts(new Date());
      var get = function (t) { for (var i = 0; i < parts.length; i++) if (parts[i].type === t) return parts[i].value; return ''; };
      var day = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 }[get('weekday')];
      var hr = parseInt(get('hour'), 10) % 24;
      return h.days.indexOf(day) > -1 && hr >= h.from && hr < h.to;
    } catch (e) { return false; }
  }

  function MkForm(root) {
    this.root = root;
    this.type = root.getAttribute('data-mk-form');
    this.cfg = CFG[this.type];
    if (!this.cfg) return;
    this.loc = root.getAttribute('data-location') || 'page';
    this.page = root.getAttribute('data-page-type') || '';
    this.product = root.getAttribute('data-product') || '';
    this.start = Date.now();
    this.idx = 0;
    this.sending = false;
    this.values = {};
    this.history = [];
    this.leadSent = false;
    this.lastSig = '';
    this.build();
  }

  MkForm.prototype.build = function () {
    var self = this, cfg = this.cfg, single = cfg.layout === 'single';
    this.root.textContent = '';
    this.root.classList.add('mk-form--' + cfg.layout);
    var form = el('form', { class: 'mk-form__form', novalidate: true, autocomplete: 'on' });
    var live = el('div', { class: 'mk-form__live', 'aria-live': 'polite', role: 'status' });
    var bar = el('div', { class: 'mk-form__progress', 'aria-hidden': 'true' }, [el('span', { class: 'mk-form__progress-bar' })]);
    var count = el('p', { class: 'mk-form__count' });
    var stage = el('div', { class: 'mk-form__stage' });
    // honeypot, hidden from people and screen readers
    var hp = el('div', { class: 'mk-form__hp', 'aria-hidden': 'true' }, [
      el('label', { for: 'mk-hp-' + uid(), text: 'Leave this empty' }),
      el('input', { type: 'text', name: 'mk_website_url', tabindex: '-1', autocomplete: 'off' })
    ]);
    this.stage = stage;
    this.steps = cfg.steps.map(function (s, i) { return self.renderStep(self.resolve(s, null), i, single, s); });
    this.steps.forEach(function (s) { stage.appendChild(s.node); });

    var back = el('button', { type: 'button', class: 'mk-btn mk-btn--ghost mk-form__back', text: 'Back' });
    var next = el('button', { type: 'button', class: 'mk-btn mk-form__next', text: 'Next' });
    var submit = el('button', { type: 'submit', class: 'mk-btn mk-form__submit', text: cfg.submitLabel || 'Send my request' });
    var err = el('p', { class: 'mk-form__error', role: 'alert', hidden: true });
    var nav = el('div', { class: 'mk-form__nav' }, [back, next, submit]);
    if (!single) form.appendChild(bar);
    if (!single) form.appendChild(count);
    form.appendChild(stage); form.appendChild(hp); form.appendChild(err); form.appendChild(nav); form.appendChild(live);
    if (cfg.liveCall) {
      var lc = cfg.liveCall;
      var bar2 = el('div', { class: 'mk-live', hidden: true, role: 'complementary', 'aria-label': 'Call a sauna expert now' }, [
        el('span', { class: 'mk-live__dot', 'aria-hidden': 'true' }),
        el('span', { class: 'mk-live__text' }, [el('strong', { text: 'Sauna experts are available now.' }), ' Skip the form and talk to us.']),
        el('a', { class: 'mk-live__btn', href: 'tel:' + lc.tel, 'data-mk-call': '', 'data-cta': 'form_live_bar', text: 'Call ' + lc.phone })
      ]);
      form.appendChild(bar2); this.liveBar = bar2;
    }
    this.root.appendChild(form);
    Object.assign(this, { form: form, live: live, bar: bar, count: count, back: back, next: next, submit: submit, err: err });

    back.addEventListener('click', function () { self.goBack(); });
    next.addEventListener('click', function () { self.advance(); });
    form.addEventListener('submit', function (e) { e.preventDefault(); self.onSubmit(); });
    form.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.tagName !== 'TEXTAREA' && e.target.tagName !== 'BUTTON' && cfg.layout === 'steps') {
        e.preventDefault();
        if (!self.submit.hidden) self.onSubmit(); else self.advance();
      }
    });
    form.addEventListener('focusin', function () { if (!self.started) { self.started = true; self.push({ event: 'mk_form_start', form_id: self.type, form_name: cfg.name }); } });
    this.steps.forEach(function (st) { st.fields.forEach(function (f) { if (f.control && (f.def.key === 'email' || f.def.key === 'phone')) f.control.addEventListener('change', function () { self.savePartial('email_entered', false); }); }); });
    this.go(0, true);
  };

  MkForm.prototype.renderStep = function (s, i, single, orig) {
    var node = el('fieldset', { class: 'mk-step', 'data-step': i });
    var head = el('legend', { class: 'mk-step__title', text: s.title });
    node.appendChild(head);
    if (s.hint && !single) node.appendChild(el('p', { class: 'mk-step__hint', text: s.hint }));
    if (s.type === 'callnow') {
      node.classList.add('mk-step--call');
      node.appendChild(el('div', { class: 'mk-call' }, [
        el('p', { class: 'mk-call__live' }, [el('span', { class: 'mk-call__dot', 'aria-hidden': 'true' }), 'We are open now']),
        el('a', { class: 'mk-btn mk-call__btn', href: 'tel:' + s.tel, 'data-mk-call': '' }, ['Call ' + s.phone]),
        el('p', { class: 'mk-call__sub', text: 'Or keep going and we will reach out to you within 48 hours.' })
      ]));
    }
    var grid = el('div', { class: 'mk-step__fields mk-step__fields--' + Math.min(s.fields.length, 2) });
    var self = this;
    var fields = s.fields.map(function (f) { var r = renderField(f); if (f.autoAdvance) r.onPick = function () { setTimeout(function () { if (self.idx === i) self.advance(); }, 260); }; if (s.fields.length === 1 && f.type === 'cards') r.node.classList.add('mk-field--solo'); grid.appendChild(r.node); return r; });
    node.appendChild(grid);
    return { node: node, fields: fields, def: s, orig: orig || s };
  };

  // Date rules for fields with weekdaysOnly / minDaysAhead (showroom visits). Local calendar dates, YYYY-MM-DD.
  function addDays(d, n) { var x = new Date(d.getFullYear(), d.getMonth(), d.getDate()); x.setDate(x.getDate() + n); return x; }
  function ymd(d) { return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2); }
  function dateProblem(f, v) {
    if (f.type !== 'date' || !v || (!f.weekdaysOnly && f.minDaysAhead == null)) return '';
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(v);
    if (!m) return 'Please enter a valid date.';
    var d = new Date(+m[1], +m[2] - 1, +m[3]);
    if (f.minDaysAhead != null && v < ymd(addDays(new Date(), f.minDaysAhead))) return 'Please choose a date from tomorrow onward.';
    if (f.weekdaysOnly && (d.getDay() === 0 || d.getDay() === 6)) return 'Please choose a weekday. The showroom is open Monday to Friday.';
    return '';
  }

  function renderField(f) {
    var id = 'mk-' + f.key + '-' + uid();
    var wrap = el('div', { class: 'mk-field mk-field--' + f.type + (f.required ? ' is-required' : '') });
    var errId = id + '-err';
    var msg = el('span', { class: 'mk-field__msg', id: errId, hidden: true });
    var api = { def: f, node: wrap, msg: msg };

    function label(forId) { return el('label', { class: 'mk-field__label', for: forId }, [f.label, f.required ? el('span', { class: 'mk-field__req', 'aria-hidden': 'true', text: ' *' }) : el('span', { class: 'mk-field__opt', text: ' (optional)' })]); }

    if (f.type === 'cards') {
      var legend = el('div', { class: 'mk-field__label', id: id + '-l' }, [f.label]);
      var list = el('div', { class: 'mk-cards' + (f.compact ? ' mk-cards--compact' : '') + (f.tiles ? ' mk-cards--tiles' : '') + (f.multi ? '' : ' mk-cards--single'), role: f.multi ? 'group' : 'radiogroup', 'aria-labelledby': id + '-l' });
      var inputs = [];
      f.options.forEach(function (o, k) {
        var oid = id + '-' + k;
        var inp = el('input', { type: f.multi ? 'checkbox' : 'radio', name: id, id: oid, value: o.v, class: 'mk-card__input' });
        var imgUrl = o.img || (o.c && window.MK_CIMG && window.MK_CIMG[o.c]) || (window.MK_IMAGES && window.MK_IMAGES[o.v]) || '';
        var plain = f.tiles && !imgUrl;
        var thumb = imgUrl ? el('span', { class: 'mk-card__img', style: 'background-image:url(' + imgUrl + ')' }) : (plain ? el('span', { class: 'mk-card__img mk-card__img--plain', 'aria-hidden': 'true' }) : null);
        var lab = el('label', { class: 'mk-card' + (imgUrl || plain ? ' has-img' : ''), for: oid }, [
          inp,
          thumb,
          el('span', { class: 'mk-card__text' }, [o.t || o.v, o.sub ? el('small', { class: 'mk-card__sub', text: o.sub }) : null]),
          el('span', { class: 'mk-card__check', 'aria-hidden': 'true' })
        ]);
        inp.addEventListener('change', function () {
          if (f.multi && f.exclusive) {
            if (inp.value === f.exclusive && inp.checked) inputs.forEach(function (i) { if (i !== inp) { i.checked = false; i.parentNode.classList.remove('is-checked'); } });
            else if (inp.value !== f.exclusive && inp.checked) inputs.forEach(function (i) { if (i.value === f.exclusive) { i.checked = false; i.parentNode.classList.remove('is-checked'); } });
          }
          if (!f.multi) inputs.forEach(function (i) { i.parentNode.classList.toggle('is-checked', i.checked); });
          else lab.classList.toggle('is-checked', inp.checked);
          if (!f.multi && f.autoAdvance && api.onPick) api.onPick(inp.value);
        });
        inputs.push(inp);
        list.appendChild(lab);
      });
      api.inputs = inputs; api.get = function () { return inputs.filter(function (i) { return i.checked; }).map(function (i) { return i.value; }); };
      wrap.appendChild(legend); wrap.appendChild(list); wrap.appendChild(msg);
      inputs.forEach(function (i) { i.addEventListener('change', function () { api.clear(); }); });
    } else {
      var control;
      if (f.type === 'textarea') control = el('textarea', { id: id, name: f.key, rows: '4', placeholder: f.placeholder || ' ' });
      else if (f.type === 'select') {
        control = el('select', { id: id, name: f.key });
        control.appendChild(el('option', { value: '', text: 'Select...' }));
        if (f.groups) f.groups.forEach(function (g) { var og = el('optgroup', { label: g[0] }); g[1].forEach(function (o) { og.appendChild(el('option', { value: o, text: o })); }); control.appendChild(og); });
        else (f.options || []).forEach(function (o) { control.appendChild(el('option', { value: o, text: o })); });
      } else control = el('input', { id: id, name: f.key, type: f.type === 'tel' ? 'tel' : f.type, placeholder: f.placeholder || ' ', inputmode: f.type === 'tel' ? 'tel' : false });
      if (f.type === 'date' && f.minDaysAhead != null) control.setAttribute('min', ymd(addDays(new Date(), f.minDaysAhead)));
      if (f.autocomplete) control.setAttribute('autocomplete', f.autocomplete);
      if (f.required) control.setAttribute('aria-required', 'true');
      control.setAttribute('aria-describedby', errId);
      api.control = control; api.get = function () { return control.value.trim(); };
      wrap.appendChild(label(id)); wrap.appendChild(control); wrap.appendChild(msg);
      control.addEventListener('input', function () { api.clear(); });
      control.addEventListener('change', function () { api.clear(); var m = dateProblem(f, api.get()); if (m) api.fail(m); });
    }
    api.clear = function () { wrap.classList.remove('has-error'); msg.hidden = true; (api.control || {}).removeAttribute && api.control.removeAttribute('aria-invalid'); };
    api.fail = function (t) { wrap.classList.add('has-error'); msg.textContent = t; msg.hidden = false; if (api.control) api.control.setAttribute('aria-invalid', 'true'); };
    return api;
  }

  // ---- conditional steps ------------------------------------------------------
  // A step may define showIf: { key, in: [...] } and byKey: { <value of key>: { title, hint, options } }.
  MkForm.prototype.valueOf = function (key) {
    for (var i = 0; i < this.steps.length; i++) {
      for (var j = 0; j < this.steps[i].fields.length; j++) {
        var f = this.steps[i].fields[j];
        if (f.def.key === key) { var v = f.get(); return Array.isArray(v) ? v[0] || '' : v; }
      }
    }
    return '';
  };
  MkForm.prototype.isVisible = function (i) {
    var c = this.steps[i].orig.showIf;
    if (!c) return true;
    if (c.hours) return inHours(c.hours);
    var v = this.valueOf(c.key);
    if (!v) return true;                      // nothing chosen yet: count it, so the progress bar is stable
    return c['in'].indexOf(v) > -1;
  };
  MkForm.prototype.visibleIdx = function () { var o = [], self = this; this.steps.forEach(function (s, i) { if (self.isVisible(i)) o.push(i); }); return o; };
  // Build the concrete definition of a conditional step for the chosen category.
  MkForm.prototype.resolve = function (def, cat) {
    if (!def.byKey) return def;
    var pick = (cat && def.byKey[cat]) || def.byKey['default'] || def.byKey[Object.keys(def.byKey)[0]];
    var m = market(), cur = m === 'US' ? 'USD' : 'CAD';
    var opts = Array.isArray(pick.options) ? pick.options : (pick.options[m] || pick.options.CA);
    var out = Object.assign({}, def, { title: pick.title || def.title, hint: (pick.hint || def.hint || '').replace('{cur}', cur) });
    out.fields = def.fields.map(function (f) { return Object.assign({}, f, { options: opts }); });
    return out;
  };
  MkForm.prototype.rebuildStep = function (i, cat) {
    var old = this.steps[i];
    var fresh = this.renderStep(this.resolve(old.orig, cat), i, this.cfg.layout === 'single', old.orig);
    old.node.parentNode.replaceChild(fresh.node, old.node);
    this.steps[i] = fresh;
  };

  MkForm.prototype.validateStep = function (i) {
    var ok = true, first = null;
    this.steps[i].fields.forEach(function (f) {
      var v = f.get(), d = f.def, empty = Array.isArray(v) ? !v.length : !v;
      f.clear();
      if (d.required && empty) { f.fail(d.type === 'cards' ? 'Please choose at least one.' : 'This field is required.'); ok = false; first = first || f; return; }
      if (!empty && d.type === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)) { f.fail('Please enter a valid email address.'); ok = false; first = first || f; }
      if (!empty && d.type === 'tel' && v.replace(/\D/g, '').length < 7) { f.fail('Please enter a valid phone number.'); ok = false; first = first || f; }
      var dp = empty ? '' : dateProblem(d, v);
      if (dp) { f.fail(dp); ok = false; first = first || f; }
    });
    if (!ok && first) { var t = first.control || (first.inputs && first.inputs[0]); if (t) t.focus(); }
    return ok;
  };

  MkForm.prototype.nextVisible = function (from, dir) {
    var n = from + dir;
    while (n >= 0 && n < this.steps.length) {
      if (this.isVisible(n)) return n;
      n += dir;
    }
    return -1;
  };

  MkForm.prototype.advance = function () {
    if (!this.validateStep(this.idx)) return;
    if (this.cfg.partial && this.steps[this.idx].fields.some(function (f) { return f.def.key === 'email'; })) this.savePartial('contact_complete', true);
    var n = this.nextVisible(this.idx, 1);
    if (n < 0) return;
    var o = this.steps[n].orig;
    if (o.byKey) this.rebuildStep(n, this.valueOf(o.byKeyField || (o.showIf && o.showIf.key)));
    this.history.push(this.idx);
    this.go(n);
  };

  MkForm.prototype.goBack = function () { var p = this.history.pop(); if (p == null) p = this.nextVisible(this.idx, -1); if (p >= 0) this.go(p); };

  // Cold plunge picked: switch the whole experience to the site's icy blue (same #96E1FF as the Plunges & Showers nav)
  MkForm.prototype.applyTheme = function () {
    var cold = this.valueOf('mk_product_category') === 'Cold Plunge';
    var nodes = [this.root, this.root.closest('.mk-lead'), this.root.closest('#mk-quote-dialog')];
    nodes.forEach(function (n) { if (n) n.classList.toggle('mk-cold', cold); });
  };

  // Live call bar: only during business hours, after the first answer, and not on the dedicated call step
  MkForm.prototype.updateLive = function (n) {
    if (!this.liveBar) return;
    var onCall = this.steps[n] && this.steps[n].def.type === 'callnow';
    this.liveBar.hidden = !(inHours(this.cfg.liveCall.hours) && n >= 1 && !onCall);
  };

  MkForm.prototype.go = function (n, init) {
    var single = this.cfg.layout === 'single';
    if (n < 0 || n >= this.steps.length) return;
    this.idx = n;
    this.applyTheme();
    this.steps.forEach(function (s, i) { var on = single || i === n; s.node.hidden = !on; s.node.classList.toggle('is-active', on); });
    var vis = this.visibleIdx(), pos = Math.max(vis.indexOf(n), 0), total = vis.length || this.steps.length;
    var last = single || n === vis[vis.length - 1];
    this.back.hidden = single || pos === 0;
    this.updateLive(n);
    this.next.hidden = last;
    this.next.textContent = this.steps[n].def.nextLabel || 'Next';
    this.submit.hidden = !last;
    this.count.textContent = single ? '' : 'Step ' + (pos + 1) + ' of ' + total;
    this.bar.firstChild.style.width = Math.round(((pos + 1) / total) * 100) + '%';
    if (!init && !single) {
      var f = this.steps[n].node.querySelector('input:not([type=hidden]),select,textarea');
      if (f && f.type !== 'radio' && f.type !== 'checkbox') f.focus({ preventScroll: true });
      this.live.textContent = this.count.textContent + ': ' + this.steps[n].def.title;
    }
  };

  MkForm.prototype.collect = function () {
    var out = {}, self = this;
    this.steps.forEach(function (s, i) {
      if (!self.isVisible(i)) return;
      s.fields.forEach(function (f) { var v = f.get(); out[f.def.key] = Array.isArray(v) ? v.join('; ') : v; });
    });
    if (self.cfg.hidden) Object.assign(out, self.cfg.hidden);   // answers the page already knows (for example heater advice)
    // category with no follow-up question: carry the category as the product interest
    if (out.mk_product_category && !out.mk_products_interested) out.mk_products_interested = out.mk_product_category;
    return out;
  };

  MkForm.prototype.tracking = function () {
    var ft = json(cookie('mk_ft') || '{}'), lt = json(cookie('mk_lt') || '{}');
    return {
      mk_form_name: this.cfg.name, mk_form_page_url: location.origin + location.pathname,
      mk_ft_source: ft.s || '', mk_ft_medium: ft.m || '', mk_ft_campaign: ft.c || '', mk_ft_term: ft.t || '', mk_ft_content: ft.ct || '',
      mk_ft_landing_page: ft.lp || '', mk_ft_referrer: ft.r || '', mk_ft_date: ft.d || '', mk_ft_gclid: ft.g || '', mk_ft_gbraid: ft.gb || '', mk_ft_wbraid: ft.wb || '', mk_ft_fbclid: ft.fb || '',
      mk_lt_source: lt.s || '', mk_lt_medium: lt.m || '', mk_lt_campaign: lt.c || '', mk_lt_gclid: lt.g || ''
    };
  };

  MkForm.prototype.push = function (o) { (window.dataLayer = window.dataLayer || []).push(o); };

  // Everything answered so far, ready for the HubSpot Forms API
  MkForm.prototype.payload = function (status) {
    var vals = this.collect();
    var data = Object.assign({}, vals, this.tracking(), { mk_form_status: status });
    var fields = Object.keys(data).filter(function (k) { return data[k] !== '' && data[k] != null; }).map(function (k) { return { objectTypeId: '0-1', name: k, value: String(data[k]) }; });
    return { vals: vals, body: { submittedAt: String(Date.now()), fields: fields, context: { hutk: cookie('hubspotutk') || undefined, pageUri: location.origin + location.pathname, pageName: document.title } } };
  };
  MkForm.prototype.post = function (body, guid) {
    return fetch('https://api.hsforms.com/submissions/v3/integration/submit/' + CFG.portal + '/' + (guid || this.cfg.guid), { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body), keepalive: true })
      .then(function (r) { if (!r.ok) throw new Error('hubspot ' + r.status); return r; });
  };
  // Save the lead as soon as there is an email, then keep updating the same contact as more is answered
  MkForm.prototype.savePartial = function (status, fire) {
    var self = this;
    if (!this.cfg.partial || this.sending) return Promise.resolve();
    var hp = this.form.querySelector('[name=mk_website_url]');
    if ((hp && hp.value) || Date.now() - this.start < 3000) return Promise.resolve();
    var p = this.payload(status);
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(p.vals.email || '')) return Promise.resolve();
    var sig = JSON.stringify(p.body.fields.map(function (f) { return f.name + '=' + f.value; }));
    var after = function () { if (fire && !self.leadSent) return self.fireLead(p.vals); };
    if (sig === this.lastSig) return Promise.resolve(after());
    this.lastSig = sig;
    return this.post(p.body).then(after).catch(function () { self.lastSig = ''; });
  };
  MkForm.prototype.fireLead = function (vals) {
    var self = this, cfg = this.cfg, m = market();
    this.leadSent = true;
    var ev = { event: 'generate_lead', form_id: this.type, form_name: cfg.name, form_type: this.type, form_location: this.loc, page_type: this.page,
      product_handle: this.product, product_category: vals.mk_product_category || '', capacity: vals.mk_capacity || '', budget: vals.mk_budget || '',
      market: m, lead_value: cfg.value, value: cfg.value, currency: m === 'US' ? 'USD' : 'CAD' };
    var email = (vals.email || '').toLowerCase(), phone = (vals.phone || '').replace(/\D/g, '');
    if (phone.length === 10) phone = '1' + phone;
    return Promise.all([sha256(email), phone ? sha256('+' + phone) : Promise.resolve('')]).then(function (h) {
      var ud = {}; if (h[0]) ud.sha256_email_address = h[0]; if (h[1]) ud.sha256_phone_number = h[1];
      if (ud.sha256_email_address || ud.sha256_phone_number) self.push({ event: 'mk_user_data', user_data: ud });
      self.push(ev);
    });
  };

  MkForm.prototype.onSubmit = function () {
    var self = this, cfg = this.cfg;
    if (this.sending) return;
    for (var i = 0; i < this.steps.length; i++) { if (this.isVisible(i) && !this.validateStep(i)) { this.go(i); return; } }
    var hp = this.form.querySelector('[name=mk_website_url]');
    var tooFast = Date.now() - this.start < 3000;
    this.sending = true; this.submit.disabled = true; this.submit.textContent = 'Sending...'; this.err.hidden = true;
    var vals = this.collect();
    if (hp && hp.value) { return this.done(vals, true); }      // bot: pretend success, send nothing
    if (tooFast) { return this.done(vals, true); }
    var p = this.payload('complete');
    this.post(p.body, cfg.finalGuid)   // final submit goes to the form that emails the client (partial saves stay silent)
      .then(function () { self.done(vals, false); })
      .catch(function (e) { self.fail(e); });
  };

  MkForm.prototype.fail = function (e) {
    this.sending = false; this.submit.disabled = false; this.submit.textContent = this.cfg.submitLabel || 'Send my request';
    var tel = this.root.getAttribute('data-phone') || this.cfg.fallbackPhone || '';
    this.err.hidden = false;
    this.err.textContent = 'Something went wrong sending your request. Please try again' + (tel ? ' or call us at ' + tel : '') + '.';
    this.push({ event: 'mk_form_error', form_id: this.type, form_name: this.cfg.name, error: String(e && e.message || e).slice(0, 80) });
  };

  MkForm.prototype.done = function (vals, silent) {
    var self = this;
    if (silent) { this.success(vals); return; }
    var p;
    if (this.leadSent) { this.push({ event: 'mk_form_complete', form_id: this.type, form_name: this.cfg.name }); p = Promise.resolve(); }
    else p = this.fireLead(vals);
    p.then(function () {
      // Optional form-specific conversion event (no personal data), e.g. showroom_visit_request for Meta Schedule and its own Google Ads conversion
      if (self.cfg.successEvent) { var m = market(); self.push({ event: self.cfg.successEvent, form_id: self.type, form_name: self.cfg.name, form_location: self.loc, page_type: self.page, market: m, value: self.cfg.value, currency: m === 'US' ? 'USD' : 'CAD' }); }
      self.success(vals);
    });
  };

  var ICONS = {
    flame: '<svg viewBox="0 0 24 24" width="38" height="38" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round" stroke-linecap="round"><path d="M12 2c3 4 6 6.5 6 11a6 6 0 0 1-12 0c0-2 .8-3.4 2-4.8.4 1.4 1.2 2.2 2.2 2.6C10 8.2 10.5 5 12 2Z"/><path d="M12 22a3 3 0 0 1-3-3c0-1.6 1.3-2.3 3-4.5 1.7 2.2 3 2.9 3 4.5a3 3 0 0 1-3 3Z" opacity=".6"/></svg>',
    snow: '<svg viewBox="0 0 24 24" width="38" height="38" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2v20M3.3 7l17.4 10M3.3 17 20.7 7"/><path d="m9.5 3.8 2.5 2 2.5-2M9.5 20.2l2.5-2 2.5 2M4.2 10.2l3.2-.4-.9-3.1M19.8 13.8l-3.2.4.9 3.1M4.2 13.8l3.2.4-.9 3.1M19.8 10.2l-3.2-.4.9-3.1"/></svg>'
  };
  function rootPath(p) { var r = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; return r.replace(/\/$/, '') + p; }

  MkForm.prototype.success = function (vals) {
    vals = vals || {};
    var cfg = this.cfg, by = cfg.successByCategory, cat = vals.mk_product_category || '';
    var s = (by && (by[cat] || by['default'])) || cfg.success;
    var name = (vals.firstname || '').trim();
    var fill = function (t) { return (t || '').replace('{name}', name || 'there'); };
    var kids = [];
    if (s.icon && ICONS[s.icon]) { var ic = el('span', { class: 'mk-success__icon mk-success__icon--' + s.icon, 'aria-hidden': 'true' }); ic.innerHTML = ICONS[s.icon]; kids.push(ic); }
    else kids.push(el('span', { class: 'mk-success__tick', 'aria-hidden': 'true' }));
    kids.push(el('h3', { class: 'mk-success__title', text: fill(s.title) }));
    kids.push(el('p', { class: 'mk-success__body', text: fill(s.body) }));
    var chipVals = cfg.chipKeys ? cfg.chipKeys.map(function (k) { return vals[k]; }) : [vals.mk_product_category, vals.mk_products_interested, vals.mk_capacity, vals.mk_budget];
    var chips = chipVals.filter(function (x, i, a) { return x && !/not sure/i.test(x) && a.indexOf(x) === i; });
    if (chips.length) kids.push(el('ul', { class: 'mk-success__chips', 'aria-label': 'Your request' }, chips.map(function (c) { return el('li', { text: c }); })));
    if (s.ctas && s.ctas.length) kids.push(el('div', { class: 'mk-success__ctas' }, s.ctas.map(function (c) { return el('a', { class: 'mk-btn' + (c.ghost ? ' mk-btn--ghost' : ''), href: rootPath(c.href), text: c.label }); })));
    var box = el('div', { class: 'mk-success', role: 'status', tabindex: '-1' }, kids);
    this.root.textContent = ''; this.root.appendChild(box); box.focus();
    this.root.dispatchEvent(new CustomEvent('mk:success', { bubbles: true }));
  };

  function init(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-mk-form]'), function (r) {
      if (r.__mk) return; r.__mk = new MkForm(r);
    });
  }

  // Showcase videos: clean poster with a play button; native controls appear once playing
  function initVideos(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('.mk-vcard video, .mk-rooms__video video'), function (v) {
      if (v.__mkv) return; v.__mkv = true;
      var fig = v.closest('.mk-vcard, .mk-rooms__video');
      var btn = el('button', { type: 'button', class: 'mk-vcard__play', 'aria-label': 'Play video' });
      v.controls = false;
      function place() { var h = v.getBoundingClientRect().height; btn.style.top = Math.max(0, h / 2 - btn.offsetHeight / 2) + 'px'; }
      fig.insertBefore(btn, v.nextSibling);
      place(); window.addEventListener('resize', place); v.addEventListener('loadedmetadata', place);
      var go = function () { v.controls = true; btn.hidden = true; var p = v.play(); if (p && p.catch) p.catch(function () { btn.hidden = false; }); };
      btn.addEventListener('click', go);
      v.addEventListener('click', function () { if (!v.controls) go(); });
      v.addEventListener('ended', function () { v.controls = false; btn.hidden = false; place(); });
    });
  }
  document.addEventListener('DOMContentLoaded', function () { initVideos(); });
  if (document.readyState !== 'loading') initVideos();
  document.addEventListener('shopify:section:load', function (e) { initVideos(e.target); });
  window.MkForms = { init: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-mk-call]');
    if (a) (window.dataLayer = window.dataLayer || []).push({ event: 'click_to_call', cta_location: a.getAttribute('data-cta') || 'quote_form_step', phone_number: (a.getAttribute('href') || '').replace('tel:', '') });
  });

  // Quote modal: any element with [data-mk-open-quote] opens it
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-mk-open-quote]');
    if (!t) return;
    var d = document.getElementById('mk-quote-dialog');
    if (!d) return;
    e.preventDefault();
    if (typeof d.showModal === 'function') d.showModal(); else d.setAttribute('open', '');
    var cta = t.getAttribute('data-cta') || 'quote_cta';
    (window.dataLayer = window.dataLayer || []).push({ event: 'quote_cta_click', cta_location: cta, page_type: d.getAttribute('data-page-type') || '', product_handle: d.getAttribute('data-product') || '' });
    if (window.MkForms) MkForms.init(d);
  });
  document.addEventListener('click', function (e) {
    var d = e.target.closest && e.target.closest('#mk-quote-dialog');
    if (!d) return;
    if (e.target.closest('[data-mk-close]') || e.target === d) { d.close ? d.close() : d.removeAttribute('open'); }
  });
  document.addEventListener('mk:success', function (e) { var d = e.target.closest && e.target.closest('#mk-quote-dialog'); if (d) { d.classList.add('is-done'); } });
})();
